import Box from "@@/elements/Box";
import NavButton from ".";
import styles from "./index.module.scss";

const NavButtonWrapper = () => (
  <Box gap={4} flexDirection="row">
    <Box className={styles.button_wrapper}>
      <NavButton direction="left" />
    </Box>
    <Box className={styles.button_wrapper}>
      <NavButton direction="right" />
    </Box>
  </Box>
);

export default NavButtonWrapper;
